import type { FunctionComponent } from "react";
import { LinkWithDMSCampaignSliderAdminPartial } from "../../../../partials/admin/menus/campaign/link-with-dms-campaign-slider.admin.partials";

export const LinkWithDMSCampaignSliderAdminScreen: FunctionComponent = () => {
    return <LinkWithDMSCampaignSliderAdminPartial />;
};
